import AMapLoader from '@amap/amap-jsapi-loader'
import { App, reactive } from 'vue'
import { AMapConfig } from '/@/constants/index'
import { DEFAULT_MAP_CENTER_GCJ02 } from '/@/utils/map-coordinate'

export function useGMapManage () {
  const state = reactive<{
    aMap: any,
    map: any,
    mouseTool: any,
    commonControlsVisible: boolean,
    commonControlsMounted: boolean,
    mapTypeControlVisible: boolean,
    mapTypeControlMounted: boolean,
  }>({
    aMap: null, // Map类
    map: null, // 地图对象
    mouseTool: null,
    commonControlsVisible: false,
    commonControlsMounted: false,
    mapTypeControlVisible: false,
    mapTypeControlMounted: false,
  })
  const commonControls = {
    toolBar: null as any,
    controlBar: null as any,
    mapType: null as any,
  }
  const mapLayers = {
    satellite: null as any,
  }
  let defaultBaseLayerInstalled = false

  function setDefaultSatelliteLayer () {
    if (!state.map || !state.aMap || defaultBaseLayerInstalled) {
      return
    }
    if (!mapLayers.satellite) {
      mapLayers.satellite = new state.aMap.TileLayer.Satellite()
    }
    // Set the initial base only. Re-entering a route must not replace the
    // complete layer collection (including model and wayline GLCustomLayers).
    const customLayers = (state.map.getLayers?.() || []).filter((layer: any) =>
      state.aMap.GLCustomLayer && layer instanceof state.aMap.GLCustomLayer)
    state.map.setLayers([mapLayers.satellite, ...customLayers])
    defaultBaseLayerInstalled = true
  }

  function getCommonControls () {
    if (!state.aMap) {
      return commonControls
    }
    if (!commonControls.toolBar) {
      commonControls.toolBar = new state.aMap.ToolBar({
        locate: false,
        position: {
          right: '16px',
          bottom: '18px'
        }
      })
    }
    if (!commonControls.controlBar) {
      commonControls.controlBar = new state.aMap.ControlBar({
        position: {
          right: '16px',
          bottom: '104px'
        }
      })
    }
    if (!commonControls.mapType) {
      commonControls.mapType = new state.aMap.MapType({
        defaultType: 1,
        showTraffic: false,
        showRoad: false
      })
    }
    return commonControls
  }

  function setMapTypeControlVisible (visible: boolean) {
    state.mapTypeControlVisible = visible
    if (!state.map || !state.aMap) {
      return
    }
    if (visible && !state.commonControlsVisible) {
      return
    }
    if (state.mapTypeControlMounted === visible) {
      return
    }
    const { mapType } = getCommonControls()
    if (!mapType) {
      return
    }
    if (visible) {
      state.map.addControl(mapType)
    } else {
      state.map.removeControl(mapType)
    }
    state.mapTypeControlMounted = visible
  }

  function setCommonControlsVisible (visible: boolean) {
    state.commonControlsVisible = visible
    if (!state.map || !state.aMap) {
      return
    }
    if (visible) {
      setDefaultSatelliteLayer()
    } else {
      setMapTypeControlVisible(false)
    }
    if (state.commonControlsMounted === visible) {
      return
    }
    const controls = getCommonControls()
    ;[controls.toolBar, controls.controlBar].forEach(control => {
      if (!control) {
        return
      }
      if (visible) {
        state.map.addControl(control)
        return
      }
      state.map.removeControl(control)
    })
    state.commonControlsMounted = visible
  }

  async function initMap (container: string, app:App) {
    return AMapLoader.load({
      ...AMapConfig
    }).then((AMap) => {
      state.aMap = AMap
      defaultBaseLayerInstalled = false
      state.map = new AMap.Map(container, {
        center: [...DEFAULT_MAP_CENTER_GCJ02],
        zoom: 20,
        viewMode: '3D',
        pitch: 0,
        rotateEnable: true,
        pitchEnable: true
      })
      state.mouseTool = new AMap.MouseTool(state.map)

      // 挂在到全局
      app.config.globalProperties.$aMap = state.aMap
      app.config.globalProperties.$map = state.map
      app.config.globalProperties.$mouseTool = state.mouseTool
      setCommonControlsVisible(state.commonControlsVisible)
      setMapTypeControlVisible(state.mapTypeControlVisible)
    }).catch(e => {
      console.log(e)
    })
  }

  function globalPropertiesConfig (app:App) {
    return initMap('g-container', app)
  }

  return {
    globalPropertiesConfig,
    setDefaultSatelliteLayer,
    setCommonControlsVisible,
    setMapTypeControlVisible,
  }
}
